import React, {Component} from 'react'
import {withStyles} from '@material-ui/core/styles'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import {FuseUtils, FuseAnimate} from '@fuse'
import {bindActionCreators} from 'redux'
import ReduxMedical from "../../../../store/actionreducers/adminMedical/medical"
import ReduxGlobal from "../../../../store/actionreducers/globalView"
import ReactTable from "react-table"
import classNames from 'classnames'
import {
    MenuItem,
    Select,
    Typography,
} from '@material-ui/core'
import {UecareStatus} from "../../../../components"
import moment from "moment"


class InstitutionMedicalList extends Component {

    getFilteredArray = (entities, searchText) => {
        const arr = Object.keys(entities).map((id) => entities[id])
        if (searchText.length === 0) {
            return arr
        }
        return FuseUtils.filterArrayByString(arr, searchText)
    }

    render() {

        const {classes, medicals, searchText} = this.props

        const data = this.getFilteredArray(medicals, searchText)

        if (!data && data.length === 0) {
            return (
                <div className="flex items-center justify-center h-full">
                    <Typography color="textSecondary" variant="headline">
                        目前沒有任何人員
                    </Typography>
                </div>
            )
        }

        return (
            <FuseAnimate animation="transition.slideUpIn" delay={300}>
                <ReactTable
                    previousText='Previous'
                    nextText='Next'
                    loadingText='Loading...'
                    noDataText="目前沒有任何人員"
                    pageText='頁'
                    ofText='/共'
                    rowsText='筆'
                    className={classNames(classes.root, "-striped -highlight")}
                    getTrProps={(state, rowInfo) => {
                        return {
                            className: "cursor-pointer",
                            onClick: async () => {
                                if (rowInfo) {

                                    try {
                                        const medicalId = rowInfo.original.id;
                                        this.props.history.push({
                                            pathname: `/apps/institutionMedical/${medicalId}`,
                                            state: {redirectUrl: this.props.location.pathname}
                                        });
                                    } catch (e) {
                                        console.warn('you got an error = ', e)
                                    }
                                }
                            }
                        }
                    }}
                    data={
                        data.sort((a, b) => b.fk_user_id - a.fk_user_id)
                            .map(medical => ({
                                ...medical,
                                userId: medical.user.id,
                                phone: medical.user.phone_country_code ?
                                    `${medical.user.phone_country_code} ${medical.user.phone_number}`
                                    : medical.user.cell_phone_no ?
                                        medical.user.cell_phone_no : '-',
                                signUpAt: moment(medical.user.created_at).format('YYYY-MM-DD'),
                            }))
                    }
                    columns={[
                        {
                            Header: "使用者編號",
                            accessor: "userId",
                            filterable: true,
                            width: 96,
                            className: "justify-center",
                        },
                        {
                            Header: "姓名",
                            accessor: "user.name",
                            filterable: true,
                            className: "font-bold justify-center",
                            width: 120,
                        },
                        {
                            Header: "Email",
                            accessor: "user.email",
                            filterable: true,
                            className: "font-bold justify-center",
                        },
                        {
                            Header: "手機",
                            accessor: "phone",
                            filterable: true,
                            className: "justify-center",
                            width: 125,
                        },
                        {
                            Header: "執業縣市",
                            accessor: "city.name",
                            filterable: true,
                            className: "justify-center",
                            width: 96,
                        },
                        {
                            id: "institution",
                            Header: "服務機構",
                            accessor: d => {
                                if (d.hospital) return d.hospital.name;
                                else if (d.unvalidated_hospital_name) return d.unvalidated_hospital_name;
                            },
                            filterable: true,
                            width: 180,
                            className: "justify-center"
                        },
                        {
                            id: "division",
                            Header: "科別",
                            accessor: d => {
                                if (d.division) return d.division.total_name
                                else return '-'
                            },
                            filterable: true,
                            width: 180,
                            className: "justify-center"
                        },
                        {
                            Header: "狀態",
                            accessor: "status",
                            Cell: row => (<UecareStatus name={row.value.name} label={row.value.label}/>),
                            filterable: true,
                            className: "justify-center",
                            Filter: ({filter, onChange}) => (
                                <Select
                                    value={filter ? filter.value : ''}
                                    style={{width: "100%"}}
                                    onChange={event => {
                                        onChange(event.target.value);
                                    }}
                                    name="selectStatus"
                                >
                                    <MenuItem value="activated">已開通</MenuItem>
                                    <MenuItem value="to_call">等待通知</MenuItem>
                                    <MenuItem value="to_contract">等待簽約</MenuItem>
                                    <MenuItem value="to_validate">等待驗證信箱</MenuItem>
                                </Select>
                            ),
                            filterMethod: (filter, row) => {
                                const status = row.status.label;
                                return status === filter.value;
                            }
                        },
                        // {
                        //     Header: "核對開通",
                        //     width: 80,
                        //     Cell: row => {
                        //         if (!canActivatedStatus.includes(row.original.status.label) &&
                        //             row.original.status.label !== 'to_call') return '';
                        //         else {
                        //             return (
                        //                 <div className="flex items-center justify-center">
                        //                     <IconButton
                        //                         onClick={async (ev) => {
                        //                             ev.stopPropagation();
                        //                             const medical = row.original;
                        //                             const alertDialogInfo = {
                        //                                 title: '開通帳號',
                        //                                 message: `請問您要開通(${medical.user.name})的帳號嗎?`,
                        //                                 yesButton: {
                        //                                     label: '是',
                        //                                     onClick: async () => {
                        //                                         try {
                        //                                             openLoadingMask();
                        //                                             await enableMedical(row.original.id);
                        //                                             await getMedicals();
                        //                                             closeLoadingMask();
                        //                                         } catch (e) {
                        //                                             console.warn('you got an error = ', e);
                        //                                         }
                        //                                     },
                        //                                 },
                        //                                 noButton: {label: '否'}
                        //                             };
                        //
                        //                             openAlertDialog(alertDialogInfo); // enable medical
                        //                         }}
                        //                     >
                        //                         <Icon>how_to_reg</Icon>
                        //                     </IconButton>
                        //                 </div>
                        //             )
                        //         }
                        //     },
                        //     className: "justify-center",
                        // },
                        // {
                        //     Header: () => <div className="text-red-dark font-bold">停用<br/>帳號</div>,
                        //     width: 64,
                        //     Cell: row => {
                        //         if (row.original.status.label === account_status.disabled.label) return '';
                        //         else return (
                        //             <div className="flex items-center">
                        //                 <IconButton
                        //                     onClick={(ev) => {
                        //                         ev.stopPropagation();
                        //                         const medical = row.original;
                        //                         const alertDialogInfo = {
                        //                             title: '停用帳號',
                        //                             message: `請問您要停用帳號(${medical.user.name})嗎?`,
                        //                             yesButton: {
                        //                                 label: '是',
                        //                                 onClick: async () => {
                        //                                     try {
                        //                                         openLoadingMask();
                        //                                         await disableMedical(medical.id);
                        //                                         await getMedicals();
                        //                                         closeLoadingMask();
                        //                                     } catch (e) {
                        //                                         console.warn('you got an error = ', e);
                        //                                     }
                        //                                 },
                        //                             },
                        //                             noButton: {label: '否'}
                        //                         };
                        //
                        //                         openAlertDialog(alertDialogInfo); // disable VIP
                        //                     }}
                        //                 >
                        //                     <Icon className={"text-teal-darker"}>not_interested</Icon>
                        //                 </IconButton>
                        //             </div>
                        //         )
                        //     }
                        // },
                    ]}
                    defaultPageSize={10}
                />
            </FuseAnimate>
        )
    }
}

const styles = theme => ({
    tooltip: {
        backgroundColor: '#0abb34',
    },
    info: {
        color: '#00aaff',
    }
})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getMedicals: ReduxMedical.ActionCreator.getMedicals,
        openAlertDialog: ReduxGlobal.ActionCreator.openAlertDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
    }, dispatch)
}

function mapStateToProps({adminMedicalList: {medical}, global: {searchText}}) {
    return {
        medical,
        searchText
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(InstitutionMedicalList)));



// WEBPACK FOOTER //
// ./src/main/content/adminMedical/institutionMedical/InstitutionMedicalList.js